import api from './api';

export const loginUser = async ({ username, password }) => {
  const { data } = await api.post('/auth/login', { username, password });
  if (data.token) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
  }
  return data;
};

export const registerUser = async ({ username, email, password }) => {
  const { data } = await api.post('/auth/register', { username, email, password });
  return data;
};

export const resendVerification = async (email) => {
  const { data } = await api.post('/auth/resend-verification', { email });
  return data;
};

export const forgotPassword = async (email) => {
  const { data } = await api.post('/auth/forgot-password', { email });
  return data;
};

export const resetPassword = async ({ token, email, password, password_confirmation }) => {
  const { data } = await api.post('/auth/reset-password', {
    token,
    email,
    password,
    password_confirmation,
  });
  return data;
};

export const logout = async () => {
  try {
    // best-effort: revoke the Sanctum token server-side. Network failure
    // shouldn't block a local sign-out.
    if (localStorage.getItem('token')) {
      await api.post('/auth/logout');
    }
  } catch {
    // ignore — we still clear local state below
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const isAuthenticated = () => !!localStorage.getItem('token');
